import { VerificationStatus } from "shared/types";
import { Cell } from "../Cell";
import { IDVstatus } from "../IDVstatus";
import { ReportStatusBadge } from "../ReportStatusBadge";
import { Verification } from "../../types";
import { useAuthContext } from "providers/Auth";
import { Applicant } from "types/application";

export const IdentityVerificationCell = ({
  verification,
  applicant
}: {
  verification: Verification;
  applicant?: Applicant;
}) => {
  const { permissions } = useAuthContext();
  const shouldShowReportBadge = [
    VerificationStatus.Pending,
    VerificationStatus.Failed
  ].includes(verification.status);

  return (
    <Cell
      isDataCell
      className="relative"
      isPermitted={permissions.canAccessReports.identityVerification}
      showRestrictedFlag={!permissions.canAccessReports.identityVerification}
    >
      <IDVstatus status={verification.status} />
      {shouldShowReportBadge ? (
        <ReportStatusBadge
          verification={verification}
          applicant={applicant as Applicant}
        />
      ) : null}
    </Cell>
  );
};
